import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-youtube-video',
    templateUrl: './youtube-video.component.html',
    styleUrls: ['./youtube-video.component.scss'],
    standalone: false
})
export class YoutubeVideoComponent implements OnInit {
  @Input() item;
  constructor() {}

  ngOnInit() {}
}
